import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// element
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
// 顶部底部等公共部分
import heads from "./components/common/head.vue";
import headlogin from "./components/common/headlogin.vue";
import navs from "./components/common/nav.vue";
import banners from "./components/common/banner.vue";
import footers from "./components/common/footer.vue";
import gerenzhongxinnav from "./components/common/gerenzhongxinnav.vue";
// 热点推荐公共部分
import rediantuijian from "./components/common/rediantuijian.vue";
// 文章列表导航
import papernav from "./components/common/paperlistnav.vue";
// 下载证书公共部分
import zhengshuxiazai from "./components/download/index.vue";
// 报纸栏目介绍公共部分
import lanmujieshao from "./components/baozhilanmu/lanmujieshao.vue";
// 报纸栏目首页公共部分
import lanmuindex from "./components/baozhilanmu/lanmuindex.vue";
// 报纸栏目版面概览公共部分
import banmian from "./components/baozhilanmu/banmian.vue";
// 期刊栏目介绍公共部分
import qklanmujieshao from "./components/qikanlanmu/lanmujieshao.vue";
// 期刊栏目首页公共部分
import qklanmuindex from "./components/qikanlanmu/lanmuindex.vue";
// 期刊栏目版面概览公共部分
import qkbanmian from "./components/qikanlanmu/banmian.vue";
// echarts
// import * as echarts from "echarts";

//前置守卫 动态设置title 关键字
router.beforeEach((to, from, next) => {
    const tmcontent:any=to.meta.content
  if (tmcontent) {
    const head = document.getElementsByTagName("head");
    const meta = document.createElement("meta");
    const keywordss=document.querySelector('meta[name="keywords"]')
    if(keywordss){
        keywordss.setAttribute("content", tmcontent.keywords);
    }
    const descriptionss=document.querySelector('meta[name="description"]')
    if(descriptionss){
        descriptionss.setAttribute("content", tmcontent.description);
    }
    
    meta.content = tmcontent;
    head[0].appendChild(meta);
  }
  const tmtitle:any=to.meta.title
  if (tmtitle) {
    document.title = tmtitle
  }
  next();
});

const app = createApp(App);
// app.config.globalProperties.$echarts = echarts;
// 图片ip地址
app.config.globalProperties.$imgurl = "http://114.117.204.133:8003";

app
  .component("heads", heads)
  .component("papernav", papernav)
  .component("navs", navs)
  .component("zhengshuxiazai", zhengshuxiazai)
  .component("banners", banners)
  .component("footers", footers)
  .component("rediantuijian", rediantuijian)
  .component("lanmujieshao", lanmujieshao)
  .component("lanmuindex", lanmuindex)
  .component("banmian", banmian)
  .component("qklanmujieshao", qklanmujieshao)
  .component("qklanmuindex", qklanmuindex)
  .component("qkbanmian", qkbanmian)
  .component("headlogin", headlogin)
  .component("gerenzhongxinnav", gerenzhongxinnav)
  .use(store)
  .use(router)
  .use(ElementPlus)
  .mount("#app");
